export default __webpack_public_path__ + "static/media/nftkey-logo-circle.677c34ac.svg";